/**
 * @file channel-reserves-columns.tsx
 * @description Колонки «Резервов по каналам» для `ResponsiveList`
 * (phase19.31, зона «Склад»; разбор B — «Резервы по каналам»).
 *
 * Канал — метка без точки (это не статус, а признак записи); числа — обычным
 * шрифтом с табличными цифрами (раньше нули были моноширинными). Артикул —
 * код, моноширинным. Раскрытие строки до заказов канала — этап B (нужен
 * серверный агрегат по `StockReservation` и движениям `SALE`).
 */

import { Badge } from "../ui/badge";
import type { ListColumn } from "../ui/responsive-list-types";
import { TwoLineCell } from "../ui/TwoLineCell";
import { SALES_CHANNEL_LABEL, formatSkuName, type ChannelReserveDto } from "../../lib/api-wms";

/** «1 240» — количество с разделителем разрядов. */
function qty(value: string): string {
  return Number(value).toLocaleString("ru-RU");
}

export const CHANNEL_RESERVE_COLUMNS: ListColumn<ChannelReserveDto>[] = [
  {
    key: "channel",
    header: "Канал",
    width: "w-[160px]",
    cell: (it) => <Badge variant="outline">{SALES_CHANNEL_LABEL[it.channel]}</Badge>,
    compact: "trailing",
  },
  {
    key: "product",
    header: "Товар",
    cell: (it) => (
      <TwoLineCell primary={formatSkuName(it.sku)} secondary={<span className="font-mono">{it.sku?.code ?? "—"}</span>} />
    ),
    compact: "title",
    compactCell: (it) => formatSkuName(it.sku),
  },
  {
    key: "warehouse",
    header: "Склад",
    width: "w-[200px]",
    cell: (it) => it.warehouse.name,
    compact: "subtitle",
    // На 1024–1279 склад — второй линией под товаром: таблица влезает в блок.
    fold: { into: "product" },
  },
  {
    key: "reserved",
    header: "Резерв",
    width: "w-[112px]",
    align: "end",
    cell: (it) => <span className="tabular-nums">{qty(it.reservedQuantity)}</span>,
    compact: "meta",
    compactCell: (it) => `резерв ${qty(it.reservedQuantity)}`,
  },
  {
    key: "buffer",
    header: "Буфер",
    width: "w-[112px]",
    align: "end",
    cell: (it) => <span className="tabular-nums">{qty(it.safetyBuffer)}</span>,
    compact: "meta",
    compactCell: (it) => `буфер ${qty(it.safetyBuffer)}`,
  },
];
